import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NoGrafoResponse } from '@interfaces/corporate-registry/responses/rede-societaria.response';
import { VisaoRelacoesResponse } from '@interfaces/corporate-registry/responses/rede-visoes.response';
import { VaultMaskCnpjPipe } from '@shared/pipes/vault-mask-cnpj.pipe';
import { emAlerta } from '@shared/components/ownership-network/registry-graph-geometry';

/** Cada empresa do recorte com os vínculos que a API identificou. */
@Component({
  selector: 'app-registry-relations',
  standalone: true,
  imports: [CommonModule, VaultMaskCnpjPipe],
  templateUrl: './registry-relations.component.html',
  styleUrl: './registry-relations.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RegistryRelationsComponent {
  readonly visao = input.required<VisaoRelacoesResponse>();
  protected readonly alerta = emAlerta;

  protected badge(no: NoGrafoResponse): { texto: string; classe: string } {
    if (no.raiz) return { texto: 'Consultada', classe: 'badge--root' };
    return no.tipo === 'empresa'
      ? { texto: 'Empresa', classe: 'badge--company' }
      : { texto: 'Pessoa', classe: 'badge--person' };
  }
}
